export class ObjectUtil {
    static IsEmptyObject<T extends object>(obj: T): boolean {
        return typeof obj === 'object' && Object.keys(obj).length === 0;
    }
}
